/* ----------------------------------------------------------------------------
   BLOCS DU TIROIR PANIER

   Un seul comportement a piloter en JS : l'interrupteur « protection de
   livraison », qui ajoute ou retire du panier le produit choisi dans le bloc.

   Trois contraintes du theme dictent la forme de ce fichier :

   1. Le tiroir remplace `.cart-drawer__inner` par innerHTML et le pied par
      replaceChildren : aucun noeud, aucun etat JS ne survit a une mise a jour
      du panier. D'ou la delegation posee sur document et la garde globale,
      et d'ou l'etat lu dans le HTML rendu par Liquid a chaque rendu.
   2. Le theme attend une sequence precise pour rafraichir le tiroir :
      demander les sections a bundler, muter le panier en les demandant, puis
      emettre cart:change. Avec baseEvent « variant:add » le tiroir se met a
      jour tout de suite au lieu d'attendre 1250 ms.
   3. assets/cart-bridge.js rejoue un cart:refresh 300 ms apres toute requete
      panier s'il n'a pas vu passer de cart:change. Un rafraichissement en
      double reste sans consequence visible ici (le tiroir est deja ouvert),
      mais on emet cart:change des que possible pour l'eviter.
   -------------------------------------------------------------------------- */

(function () {
  if (window.__cartDrawerBlocksBound) return;
  window.__cartDrawerBlocksBound = true;

  function racine() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Les sections que le theme veut voir re-rendues cote serveur. */
  function sectionsABundler() {
    var sections = [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));

    return sections;
  }

  function previent(panier) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: panier }
    }));
  }

  async function basculer(bouton) {
    if (bouton.hasAttribute('aria-busy')) return;

    var actif = bouton.getAttribute('aria-checked') === 'true';
    var cleLigne = bouton.getAttribute('data-line-key');
    var variante = bouton.getAttribute('data-variant-id');
    var sections = sectionsABundler();

    /* Reponse immediate a l'ecran ; le rendu serveur confirmera. */
    bouton.setAttribute('aria-busy', 'true');
    bouton.setAttribute('aria-checked', actif ? 'false' : 'true');

    try {
      if (actif && cleLigne) {
        /* Retrait : cart/change.js renvoie le panier complet, sections
           comprises — on peut prevenir le theme sans autre requete. */
        var reponse = await fetch(racine() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: cleLigne, quantity: 0, sections: sections })
        });

        if (!reponse.ok) throw new Error('change');

        previent(await reponse.json());
      } else {
        /* Ajout : cart/add.js ne renvoie que la ligne ajoutee, il faut relire
           le panier pour donner au theme un objet complet. */
        var ajout = await fetch(racine() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{ id: Number(variante), quantity: 1 }],
            sections: sections
          })
        });
        var resultat = await ajout.json();

        if (!ajout.ok) throw new Error(resultat.description || 'add');

        var panier = await (await fetch(racine() + 'cart.js')).json();

        panier.sections = resultat.sections;
        previent(panier);
      }
    } catch (erreur) {
      /* On rend l'interrupteur a son etat reel : le panier n'a pas bouge. */
      bouton.setAttribute('aria-checked', actif ? 'true' : 'false');
      document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: String(erreur && erreur.message ? erreur.message : erreur) }
      }));
    } finally {
      bouton.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var bouton = event.target.closest('[data-cd-protect]');

    if (!bouton) return;

    event.preventDefault();
    basculer(bouton);
  });
})();
